import axiosInstance from "@/api/axios-instance";

export async function createInvite(email: string) {
  const response = await axiosInstance.post("/invite", { email });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Invite failed");
  }

  return response.data;
}
